export default __webpack_public_path__ + "static/media/MiTradeLogo.676cd84f.png";